import React from 'react';
import PropTypes from 'prop-types';

import {
  withAssetLibraryServicesLoaded,
} from '@bingads-webui-campaign-react/asset-library-services';
import { FolderAssetType } from '@bingads-webui-campaign-react/asset-library-model';
import { CampaignFetchProvider } from '@bingads-webui-campaign-react/campaign-http';
import { CopilotRepositoryProvider } from '@bingads-webui/inline-copilot';
import { VideoTemplateEditorWithAddImageWrapper } from './video-template-add-image-wrapper';

const EditVideoPageComponentWithDataServices = withAssetLibraryServicesLoaded(VideoTemplateEditorWithAddImageWrapper, { loggerTag: 'Video Template Editor' });

export const VideoTemplateEditorContextWrapper = ({
  assetLibraryConfig,
  permissions,
  isAADUser,
  isLiteLandingPageEnabled,
  isOpen,
  setIsOpen,
  videoMetaData,
  onApply,
  cid,
  aid,
  finalUrl,
  perfMarker,
  i18n,
  isCTV,
  serverContext,
  isDialog,
  loadClipchampPlayer,
  showVideoTemplateSummaryBarControl,
}) => {
  // todo: don't pilot AAD user for now, remove this check after the feature is GAed
  const isAssetLibraryAIGCMVPEnabled = !isAADUser;

  const {
    timeZone,
    preferencesService,
    activityLogger,
    oDataConfig,
    dateFormat,
  } = assetLibraryConfig;

  const useClipchamp = permissions && permissions.dynamic && permissions.dynamic.VideoTemplateUI;

  return (
    isOpen ?
      <CampaignFetchProvider>
        <CopilotRepositoryProvider
          campaignId={-1}
          recommendationType="Video" // This is used until we have a separate video recommendationType
          finalUrl={finalUrl}
          serverContext={serverContext}
          perfMarker={perfMarker}
          locale={i18n.getLocale()}
          useClipchamp={useClipchamp}
          enableLogoAndCTA
        >
          <EditVideoPageComponentWithDataServices
            accountTimeZone={timeZone}
            preferenceService={preferencesService}
            activity={activityLogger}
            assetLibraryConfig={assetLibraryConfig}
            oDataConfig={oDataConfig}
            allowedAssetType={FolderAssetType.Image}
            isAssetLibraryAIGCMVPEnabled={isAssetLibraryAIGCMVPEnabled}
            isLiteLandingPageEnabled={isLiteLandingPageEnabled}
            dateFormat={dateFormat}
            permissions={permissions}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            videoMetaData={videoMetaData}
            onApply={onApply}
            cid={cid}
            aid={aid}
            finalUrl={finalUrl}
            perfMarker={perfMarker}
            i18n={i18n}
            isCTV={isCTV}
            serverContext={serverContext}
            isDialog={isDialog}
            loadClipchampPlayer={loadClipchampPlayer}
            showVideoTemplateSummaryBarControl={showVideoTemplateSummaryBarControl}
          />
        </CopilotRepositoryProvider>
      </CampaignFetchProvider >
      : null
  );
};

VideoTemplateEditorContextWrapper.propTypes = {
  assetLibraryConfig: PropTypes.shape({
    timeZone: PropTypes.number,
    preferencesService: PropTypes.shape({}),
    activityLogger: PropTypes.shape({}),
    oDataConfig: PropTypes.shape({}),
    dateFormat: PropTypes.string,
  }).isRequired,
  permissions: PropTypes.shape({}).isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  videoMetaData: PropTypes.shape().isRequired,
  onApply: PropTypes.func.isRequired,
  cid: PropTypes.string.isRequired,
  aid: PropTypes.string.isRequired,
  finalUrl: PropTypes.string.isRequired,
  perfMarker: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({}).isRequired,
  isAADUser: PropTypes.bool,
  isLiteLandingPageEnabled: PropTypes.bool,
  isCTV: PropTypes.bool,
  serverContext: PropTypes.shape({}).isRequired,
  isDialog: PropTypes.bool,
};

VideoTemplateEditorContextWrapper.defaultProps = {
  isLiteLandingPageEnabled: false,
  isAADUser: false,
  isCTV: false,
  isDialog: false,
};
